import { useEffect, useState } from "react";
import { connectRightSideMenu } from "./RightSideMenu.connect";
import SVG_MobileIcon from "../../assets/images/svgs/Mobile.svg?react";
import SVG_CloseIcon from "../../assets/images/svgs/Close.svg?react";
import SVG_BankIcon from "../../assets/images/svgs/Bank.svg?react";
import SVG_DepositIcon from "../../assets/images/svgs/Deposit.svg?react";
import SVG_WithdrawIcon from "../../assets/images/svgs/Withdraw.svg?react";
import SVG_ChatIcon from "../../assets/images/svgs/Chat.svg?react";
import SVG_TransactionIcon from "../../assets/images/svgs/Transactions.svg?react";
import SVG_DownloadIcon from "../../assets/images/svgs/download.svg?react";
import SVG_OpenBetsIcon from "../../assets/images/svgs/openBets.svg?react";
import SVG_BettingPLIcon from "../../assets/images/svgs/bettingPL.svg?react";
import SVG_StatementIcon from "../../assets/images/svgs/statement.svg?react";
import SVG_TransferStatementIcon from "../../assets/images/svgs/transaferStatement.svg?react";
import SVG_TimeSettingIcon from "../../assets/images/svgs/timeSetting.svg?react";
import SVG_SettingIcon from "../../assets/images/svgs/Settings.svg?react";
// import SVG_RulesIcon from "../../assets/images/svgs/Rules.svg?react";
// import SVG_StopHandIcon from "../../assets/images/svgs/stopHand.svg?react";
// import SVG_CheckIcon from "../../assets/images/svgs/checkCircle.svg?react";
// import SVG_PrivacyIcon from "../../assets/images/svgs/Privacy.svg?react";
import SVG_LockIcon from "../../assets/images/svgs/lock.svg?react";
import SVG_LogOutIcon from "../../assets/images/svgs/logout.svg?react";
// import SVG_GiftIcon from "../../assets/images/menu-icons/gift1.svg?react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getCurrencyFormat } from "../../helpers/getCurrencyFormat.helper";
import ContactUs from "../ContactUs/ContactUs";
import {
  BASE_DEV_URL,
  CONFIG,
  DownloadApk,
  IS_B2C,
} from "../../config/api.config";
import { ID_TOKEN, TOKEN_EXP, USER_DATA } from "../../config/app.config";
import SVG_BonusIcon from "../../assets/images/svgs/Bonus.svg?react";
import SVG_BonusRules from "../../assets/images/svgs/Rules.svg?react";
import LockedBounus from "../Modals/LockedBounus/LockedBonus";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";

const RightSideMenu = ({
  setOpen,
  balance,
  B2C,
  user,
  actions,
  auth,
  profile,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isChecked, setIsChecked] = useState(false);
  const [LockedBonusPopUp, setLockedBonusPopUp] = useState(false);
  let userData = {};

  try {
    userData = JSON.parse(localStorage.getItem(USER_DATA) || "{}");
  } catch {
    userData = {};
  }
  const nav = useNavigate();

  const promotions = useSelector((state) => state.promotions.socials);

  const activeItems =
    promotions && Object.values(promotions)?.filter((item) => item?.is_active);
  const itemsWithUrl = activeItems?.map((item) => {
    if (item.title === "Whatsapp") {
      return { ...item, url: formatWhatsappUrl(item.url) };
    }

    return item;
  });
  const firstItem = itemsWithUrl?.[0];

  const goLogOut = async () => {
    actions.requestLogout();
    localStorage.clear();
    setOpen(false);
  };

  const [bonus, setBonus] = useState(null);

  const token = localStorage.getItem(ID_TOKEN);

  async function getBonusAmounts() {
    const res = await fetch(`${BASE_DEV_URL}user/getBonusAmounts`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!res.ok) throw new Error("network error");
    return res.json();
  }

  useEffect(() => {
    (async () => {
      try {
        const json = await getBonusAmounts();
        setBonus(json.data);
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);

  function formatWhatsappUrl(url) {
    if (/^\d{6,15}$/.test(url)) {
      return `https://wa.me/${url}`;
    }

    return url;
  }

  return (
    <div
      className="fixed top-0 left-0 z-50 w-full  h-dvh  bg-opacity-50 block"
      onClick={() => {
        setOpen(false);
      }}
    >
      <div className="undefined">
        <div
          className="fixed transition-all ease-in-out openDrawerFromRight origin-left top-0 right-0 z-50 w-[70%] max-w-sm h-full  overflow-y-auto bg-bg_Quaternary-side-right shadow-lg "
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <ul className=" overflow-y-auto h-max divide-y">
            <li className="px-3 py-2 flex items-center justify-between">
              <div className="flex items-center justify-start gap-x-1.5">
                <span>
                  <SVG_MobileIcon />
                </span>
                <span className="font-lato-bold font-semibold text-sm xs:text-base text-text_Ternary-new ">
                  {/* {user && user?.name && user?.name} */}
                  {userData?.is_signup_by_otpless &&
                  userData?.otpless_identity_type === "MOBILE"
                    ? `${userData?.country_code}-${userData?.mobile}`
                    : user && user?.name
                      ? user &&
                        user?.name &&
                        `${user?.name} ${
                          userData?.mobile
                            ? `(${userData?.country_code}-${userData?.mobile})`
                            : ""
                        }`
                      : null}
                </span>
              </div>
              <button
                className="inline-block  leading-normal relative overflow-hidden  transition duration-150 ease-in-out  active:scale-105 cursor-pointer"
                type="button"
                onClick={() => {
                  setOpen(false);
                }}
              >
                <SVG_CloseIcon />
              </button>
            </li>
            <li className="px-3 py-2  flex items-start justify-start flex-col gap-2">
              <div className="flex items-center justify-start gap-2.5">
                <span>
                  <SVG_BankIcon />
                </span>
                <span className="font-lato-bold font-semibold text-sm xs:text-base text-text_Ternary-new ">
                  Balance Information
                </span>
              </div>
              <div className=" grid grid-cols-2 gap-0.5 w-full">
                <div
                  className={`flex w-full flex-col rounded items-start bg-bg_Ternary11 border px-2 py-1 ${
                    IS_B2C ? "col-span-2" : "col-span-1"
                  }`}
                >
                  <span className="uppercase font-normal text-xxs">
                    Balance
                  </span>
                  <span className=" font-lato text-sm font-medium text-text_Success">
                    {" "}
                    {balance && balance.balance
                      ? getCurrencyFormat(balance.balance)
                      : "0.00"}
                  </span>
                </div>
                {IS_B2C && (
                  <div className="flex w-full flex-col rounded items-start bg-bg_Ternary11 border px-2 py-1 col-span-1">
                    <span className="uppercase font-normal text-xxs">
                      Free Cash
                    </span>
                    <span className=" font-lato text-sm font-medium ">
                      0.00
                    </span>
                  </div>
                )}
                <div
                  className={
                    "flex w-full flex-col rounded items-start bg-bg_Ternary11 border px-2 py-1 col-span-1"
                  }
                >
                  <span className="uppercase font-normal text-xxs">
                    Net Exposure
                  </span>
                  <span className=" font-lato text-sm font-medium text-text_Danger">
                    {" "}
                    {balance && balance.liability
                      ? getCurrencyFormat(balance.liability)
                      : "0.00"}
                  </span>
                </div>
              </div>
              <div className="flex col-span-2 items-center justify-center  w-full ">
                <div
                  id="deposit_withdraw_btn"
                  className="flex items-center justify-center w-full gap-1"
                >
                  {IS_B2C && (
                    <button
                      className=" leading-normal relative overflow-hidden  transition duration-150 ease-in-out  flex bg-none border-none shadow-none w-full cursor-pointer"
                      type="button"
                      // onClick={() => {
                      //   navigate("/deposit");
                      //   setOpen(false);
                      // }}
                      onClick={() => {
                        if (userData?.is_demo) {
                          toastr.error("", "Please login from your read ID.");
                        } else {
                          navigate("/deposit");
                          setOpen(false);
                        }
                      }}
                    >
                      <span className="text-white capitalize border  flex rounded px-3 py-1 flex-col text-[10px]  hover:opacity-100 w-full font-semibold items-center justify-center  bg-bg_HomeDepositBtnBgColor ">
                        <SVG_DepositIcon stroke="#fff" />
                        deposit
                      </span>
                    </button>
                  )}
                  {IS_B2C && (
                    <button
                      className=" leading-normal relative overflow-hidden  transition duration-150 ease-in-out  flex bg-none border-none shadow-none    w-full  cursor-pointer"
                      type="button"
                      // onClick={() => {
                      //   navigate("/withdraw");
                      //   setOpen(false);
                      // }}
                      onClick={() => {
                        if (userData?.is_demo) {
                          toastr.error("", "Please login from your read ID.");
                        } else {
                          navigate("/withdraw");
                          setOpen(false);
                        }
                      }}
                    >
                      <span className="text-white capitalize border  flex rounded px-3 py-1 flex-col text-[10px]  hover:opacity-100 w-full font-semibold items-center justify-center  bg-bg_HomeWithdrawBtnBgColor  ">
                        <SVG_WithdrawIcon stroke="#fff" />
                        withdraw
                      </span>
                    </button>
                  )}
                </div>
              </div>
            </li>

            <div className="flex flex-wrap p-2 w-full gap-2 items-center justify-center font-roboto"></div>

            {IS_B2C && (
              <li className="px-3 py-2  flex items-start justify-start flex-col gap-2">
                <div className="flex items-center justify-start gap-x-2.5">
                  <SVG_BonusIcon className="bonusInformation" />
                  <span className="font-lato-bold font-semibold text-sm xs:text-base text-text_Ternary-new  ">
                    Bonus Information
                  </span>
                </div>

                <div className=" grid grid-cols-2 gap-0.5 w-full">
                  <div className="flex w-full col-span-1 flex-col rounded items-start bg-[#f2f2f2] border px-2 py-1 ">
                    <span className="uppercase font-normal text-xxs">
                      Bonus Balance
                    </span>
                    <span className="font-lato text-sm   text-text_color_ternary ">
                      {bonus?.earnedBonus ? bonus?.earnedBonus : 0}
                    </span>
                  </div>
                  <div className="flex w-full col-span-1 flex-col rounded items-start bg-[#f2f2f2] border px-2 py-1 ">
                    <span className="uppercase font-normal text-xxs">
                      Net Exposure
                    </span>
                    <span className="font-lato text-sm   text-text_color_danger">
                      0.00
                    </span>
                  </div>
                  <div className="flex w-full col-span-1 flex-col rounded items-start bg-[#f2f2f2] border px-2 py-1 col-span-2 ">
                    <button
                      className=" leading-normal relative overflow-hidden  transition duration-150 ease-in-out  flex bg-none border-none shadow-none w-full cursor-pointer"
                      type="button"
                      onClick={() => {
                        // navigate("/deposit");
                        // setOpen(false);
                        setLockedBonusPopUp(true);
                      }}
                    >
                      <span className="text-white capitalize border  flex rounded px-3 py-1 flex-col text-[10px]  hover:opacity-100 w-full font-semibold items-center justify-center  bg-bg_HomeDepositBtnBgColor border-depositBtn ">
                        {/* <SVG_DepositIcon />
                         */}
                        <SVG_BonusIcon />
                        LOCKED BONUS{": "}
                        {bonus?.lockedBonus ? bonus?.lockedBonus : 0}
                      </span>
                    </button>
                  </div>
                  {/* <div className="flex col-span-2 text-text_color_primary1 items-center justify-between w-full">
                    <span className=" font-lato font-bold text-sm">
                      Play With Bonus
                    </span>
                    <span className=" font-lato-bold font-medium text-sm mt-2">
                      <label className="inline-flex items-center cursor-pointer relative">
                        <input
                          className="sr-only peer"
                          type="checkbox"
                          checked={isChecked}
                          disabled
                          onChange={() => setIsChecked(!isChecked)}
                        />
                        <div className="relative  bg-white border-[0.5px] font-lato rounded-full peer-checked:bg-bg_SwitchCheckedBg h-7 w-14">
                          <span
                            className={`absolute top-1/2 left-[5px] transform  -translate-y-1/2  font-bold text-text_Quaternary text-[10px]`}
                          >
                            ON
                          </span>
                          {!isChecked && (
                            <span
                              className={`absolute top-1/2 right-[5px] transform  -translate-y-1/2  font-bold text-[10px]`}
                            >
                              OFF
                            </span>
                          )}
                          <div
                            className={`bg-bg_SwitchBtnRound bg-white h-full border-[0.5px] border-border_color_primary transition-all  ease-in-out aspect-square absolute left-${
                              isChecked ? "7" : "0"
                            } rounded-full`}
                          ></div>
                        </div>
                      </label>
                    </span>
                  </div> */}
                </div>
              </li>
            )}

            {IS_B2C && (
              <li className="divide-y flex items-start justify-start flex-col">
                <span className="font-lato-bold font-semibold px-3 py-1 w-full bg-border-[#d1d1d1] text-xs xs:text-sm text-text_Ternary-new ">
                  Help &amp; Support
                </span>
                <div className="divide-y pl-5 flex items-start justify-start w-full flex-col">
                  <div className="w-full border-[#d1d1d1]">
                    <a href={firstItem?.url} target="_blank">
                      <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                        <span className="w-4 h-auto xs:w-5 text-text_Primary">
                          <SVG_ChatIcon />
                        </span>
                        <span className="font-medium text-text_Ternary-new text-sm xs:text-base">
                          Chat With Us
                        </span>
                      </div>
                    </a>
                  </div>
                  <div
                    className="w-full border-[#d1d1d1]"
                    onClick={DownloadApk}
                  >
                    <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                      <span className="w-4 h-auto xs:w-5 text-text_Primary">
                        <SVG_DownloadIcon />
                      </span>
                      <span className="font-medium text-text_Ternary-new text-sm xs:text-base">
                        Download APK
                      </span>
                    </div>
                  </div>
                </div>
              </li>
            )}
            <li className="divide-y flex items-start justify-start flex-col">
              <span className="font-lato-bold text-text_Ternary-new font-semibold px-3 py-1 w-full border-[#d1d1d1] text-xs xs:text-sm  ">
                Statements
              </span>
              <div className="divide-y pl-5 flex items-start justify-start w-full flex-col">
                {!userData?.is_demo && IS_B2C && (
                  <div className="w-full border-[#d1d1d1]">
                    <Link
                      to={"/affiliate"}
                      onClick={() => {
                        setOpen(false);
                      }}
                    >
                      <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                        <span className="w-4 h-auto xs:w-5 text-text_Primary">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 21 21"
                            fill="none"
                          >
                            <g clipPath="url(#clip0_2_27154)">
                              <path
                                d="M5.41956 2.33087C5.53248 2.22009 5.68648 2.15784 5.84691 2.15784C6.00735 2.15784 6.16119 2.22025 6.27427 2.33102L8.05331 4.07541C8.17108 4.19077 8.32744 4.2544 8.49336 4.2544C8.61977 4.2544 11.6435 4.2544 12.1735 4.2544C12.3395 4.2544 12.4957 4.19077 12.6146 4.0745L14.3624 2.36917C14.4754 2.25885 14.6289 2.1969 14.7889 2.1969C14.789 2.1969 14.7893 2.1969 14.7895 2.1969C14.9498 2.19705 15.1033 2.25946 15.2162 2.37009L20.4208 7.47141C20.6543 7.7003 20.6539 8.06971 20.4197 8.29814L18.927 9.75322C18.6443 10.0305 18.4886 10.3993 18.4886 10.7919C18.4886 11.2999 18.3421 11.7857 18.0698 12.2042C18.6623 12.9052 18.6241 13.9492 17.9544 14.6055C17.6302 14.9234 17.2057 15.1071 16.7504 15.1287C16.7296 15.5572 16.5527 15.9796 16.2196 16.306C15.8954 16.6238 15.4709 16.8075 15.0155 16.8292C14.9948 17.2577 14.8177 17.68 14.4848 18.0064C13.9605 18.5203 13.2082 18.6499 12.5729 18.4279C12.4854 18.6738 12.3417 18.9045 12.1416 19.1006C11.4267 19.8016 10.2672 19.8018 9.5521 19.1006L9.29788 18.8516C9.13902 18.6958 9.01591 18.518 8.92809 18.3284C8.21688 18.9398 7.12066 18.9262 6.42764 18.2469C6.09454 17.9205 5.91764 17.4981 5.89694 17.0697C5.44167 17.0482 5.01699 16.8643 4.69282 16.5464C4.35972 16.2201 4.18283 15.7977 4.16197 15.3692C3.70686 15.3477 3.28217 15.1638 2.95801 14.8462C2.29212 14.1935 2.25025 13.1573 2.83239 12.4563C2.40817 11.8748 2.17842 11.1807 2.17842 10.4518C2.17842 10.281 2.10801 10.1141 1.98521 9.9937L0.214951 8.25785C-0.0180931 8.02943 -0.0180931 7.66078 0.214951 7.43235L5.41956 2.33087ZM17.0995 12.9051L16.2321 12.0549C15.9886 11.8161 15.5959 11.8159 15.3522 12.0549C15.106 12.2961 15.106 12.6886 15.3522 12.9296L16.2196 13.78C16.4633 14.0188 16.8558 14.0188 17.0995 13.78C17.3456 13.5388 17.3456 13.1463 17.0995 12.9051ZM15.3647 14.6055L13.6299 12.9051C13.3862 12.6663 12.9935 12.6661 12.7498 12.9051C12.5037 13.1463 12.5037 13.5388 12.7498 13.78C13.3682 14.3861 13.4011 14.4183 14.4848 15.4805C14.7285 15.7191 15.121 15.7193 15.3647 15.4803C15.6108 15.2392 15.6108 14.8468 15.3647 14.6055ZM13.6299 17.1808C13.876 16.9397 13.876 16.5472 13.6299 16.306L12.7625 15.4557C12.5188 15.2169 12.1261 15.2169 11.8824 15.4557C11.6551 15.6785 11.6382 16.0299 11.8308 16.2725C11.8838 16.3202 11.8049 16.2436 12.7498 17.1808C12.9935 17.4197 13.386 17.4199 13.6299 17.1808ZM10.1526 18.0259L10.4068 18.275C10.6505 18.5139 11.0431 18.5139 11.2868 18.275C11.511 18.0552 11.5303 17.7102 11.3459 17.4682C11.0153 17.1431 11.0314 17.1623 10.9739 17.1009C10.728 16.9128 10.3769 16.9314 10.1526 17.1511C9.90653 17.3924 9.90669 17.7848 10.1526 18.0259ZM3.81271 14.0205C4.05642 14.2593 4.44912 14.2593 4.69282 14.0205L5.81429 12.9213C6.04859 12.6916 6.42999 12.6902 6.66602 12.9182C6.90204 13.1462 6.90345 13.5171 6.66916 13.7468L5.54753 14.846C5.30147 15.0872 5.30147 15.4797 5.54753 15.7208C5.79124 15.9597 6.18393 15.9597 6.42764 15.7208L7.54911 14.6215C7.78357 14.3919 8.16481 14.3905 8.40084 14.6185C8.63686 14.8465 8.63827 15.2176 8.40397 15.4472L7.2825 16.5464C7.03629 16.7877 7.03629 17.1801 7.2825 17.4212C7.52606 17.6602 7.91875 17.6602 8.16262 17.4212C9.34321 16.2735 9.28659 16.2986 9.40547 16.2288C9.71222 15.9718 10.0922 15.8229 10.4971 15.8027C10.5189 15.3759 10.6958 14.9554 11.0275 14.6301C11.1977 14.4635 11.3956 14.3338 11.6109 14.245C11.2025 13.5609 11.2971 12.6655 11.8951 12.0796C12.508 11.4788 13.4248 11.4061 14.1084 11.7956C14.197 11.5898 14.3264 11.3967 14.4973 11.2294C15.2124 10.5284 16.3717 10.5284 17.087 11.2294L17.183 11.3235C17.2492 11.1563 17.2841 10.9767 17.2841 10.7919C17.2841 10.0878 17.5641 9.42592 18.0734 8.92649L19.1438 7.8831L14.7879 3.61353L13.4684 4.90091C13.1735 5.18992 12.7954 5.36768 12.3869 5.41376L15.078 8.55571C15.2909 8.80442 15.2564 9.17384 15.0009 9.3809C14.3831 9.88185 13.6018 10.1188 12.8009 10.048C12.0002 9.97722 11.2755 9.60719 10.76 9.00523C10.5443 8.75346 10.1816 8.67762 9.87752 8.82045C9.25695 9.11219 8.57491 9.2187 7.90401 9.13539L3.81271 13.1456C3.56665 13.3868 3.56665 13.7793 3.81271 14.0205ZM2.83992 9.16804C3.19011 9.51121 3.38285 9.96715 3.38285 10.4518C3.38285 10.8607 3.49185 11.2529 3.69541 11.5971L6.62446 8.7263C6.02569 8.4022 5.53467 7.91499 5.20894 7.31104C5.05447 7.02448 5.16801 6.67033 5.46253 6.52003C5.75705 6.36958 6.12105 6.48005 6.27552 6.76661C6.60235 7.37269 7.16332 7.7772 7.79172 7.92704C7.81932 7.93116 7.84677 7.93696 7.87358 7.9449C8.35645 8.04209 8.87414 7.99067 9.35356 7.7653C10.1564 7.38795 11.115 7.58937 11.6859 8.25587C11.9948 8.61644 12.4296 8.83845 12.9099 8.88102C13.183 8.90513 13.4521 8.86958 13.7017 8.7794L10.9138 5.52393C10.6954 5.45908 10.4689 5.42124 10.2406 5.42124H8.49336C8.00406 5.42124 7.54425 5.23966 7.19845 4.90091L5.84676 3.57553L1.49074 7.8451L2.83992 9.16804Z"
                                fill="var(--icon-color-brand-secondary)"
                              ></path>
                            </g>
                            <defs>
                              <clipPath id="clip0_2_27154">
                                <rect
                                  width="20.5556"
                                  height="20"
                                  fill="white"
                                  transform="matrix(-1 0 0 1 20.5555 0.868774)"
                                ></rect>
                              </clipPath>
                            </defs>
                          </svg>
                        </span>
                        <span className="font-medium  text-text_Ternary-new text-sm xs:text-base">
                          Affiliate (Refer & Earn)
                        </span>
                      </div>
                    </Link>
                  </div>
                )}
                {!userData?.is_demo && IS_B2C && (
                  <div className="w-full border-[#d1d1d1]">
                    <Link
                      to={"/refer-earn"}
                      onClick={() => {
                        setOpen(false);
                      }}
                    >
                      <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                        <span className="w-4 h-auto xs:w-5 text-text_Primary">
                          <SVG_StatementIcon />
                        </span>
                        <span className="font-medium text-text_Ternary-new text-sm xs:text-base">
                          Refer and Earn
                        </span>
                      </div>
                    </Link>
                  </div>
                )}
                {IS_B2C && (
                  <div className="w-full border-[#d1d1d1]">
                    <Link
                      to={"/transactions"}
                      onClick={() => {
                        setOpen(false);
                      }}
                    >
                      <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                        <span className="w-4 h-auto xs:w-5 text-text_Primary">
                          <SVG_TransactionIcon />
                        </span>
                        <span className="font-medium text-text_Ternary-new text-sm xs:text-base">
                          Transactions
                        </span>
                      </div>
                    </Link>
                  </div>
                )}
                {IS_B2C && (
                  <div className="w-full border-[#d1d1d1]">
                    <Link
                      to={userData?.is_demo ? "#" : "/bonuses"}
                      onClick={() => {
                        setOpen(false);
                        if (userData?.is_demo) {
                          toastr.error("", "Please login from your read ID.");
                          return;
                        }
                      }}
                    >
                      <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                        <span className="w-4 h-auto xs:w-5 text-text_Primary">
                          <SVG_BonusIcon />
                        </span>
                        <span className="font-medium text-text_Ternary-new text-sm xs:text-base">
                          Bonuses
                        </span>
                      </div>
                    </Link>
                  </div>
                )}
                <div className="w-full border-[#d1d1d1]">
                  <Link
                    to={"/open-bets"}
                    onClick={() => {
                      setOpen(false);
                    }}
                  >
                    <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                      <span className="w-4 h-auto xs:w-5 text-text_Primary">
                        <SVG_OpenBetsIcon />
                      </span>
                      <span className="font-medium text-text_Ternary-new text-sm xs:text-base">
                        Open Bets
                      </span>
                    </div>
                  </Link>
                </div>
                <div className="w-full border-[#d1d1d1]">
                  <Link
                    to={"/betting-profit-loss"}
                    onClick={() => {
                      setOpen(false);
                    }}
                  >
                    <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                      <span className="w-4 h-auto xs:w-5 text-text_Primary">
                        <SVG_BettingPLIcon />
                      </span>
                      <span className="font-medium text-text_Ternary-new text-sm xs:text-base">
                        Betting Profit &amp; Loss
                      </span>
                    </div>
                  </Link>
                </div>
                <div className="w-full border-[#d1d1d1]">
                  <Link
                    to={"/account-statement"}
                    onClick={() => {
                      setOpen(false);
                    }}
                  >
                    <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                      <span className="w-4 h-auto xs:w-5 text-text_Primary">
                        <SVG_StatementIcon />
                      </span>
                      <span className="font-medium text-text_Ternary-new text-sm xs:text-base">
                        Account Statement
                      </span>
                    </div>
                  </Link>
                </div>

                {IS_B2C && (
                  <div className="w-full border-[#d1d1d1]">
                    <Link
                      to={userData?.is_demo ? "#" : "/bonus-statement"}
                      onClick={() => {
                        if (userData?.is_demo) {
                          toastr.error("", "Please login from your read ID.");
                          return;
                        } else {
                          setOpen(false);
                        }
                      }}
                    >
                      <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                        <span className="w-4 h-auto xs:w-5 text-text_Primary">
                          <SVG_BonusIcon />
                        </span>
                        <span className="font-medium text-text_Ternary-new text-sm xs:text-base">
                          Bonus Statement
                        </span>
                      </div>
                    </Link>
                  </div>
                )}
                {IS_B2C && (
                  <div className="w-full border-[#d1d1d1]">
                    <Link
                      to={userData?.is_demo ? "#" : "/bonus-rules"}
                      onClick={() => {
                        if (userData?.is_demo) {
                          toastr.error("", "Please login from your read ID.");
                          return;
                        } else {
                          setOpen(false);
                        }
                      }}
                    >
                      <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                        <span className="w-4 h-auto xs:w-5 text-text_Primary">
                          <SVG_BonusRules />
                        </span>
                        <span className="font-medium text-text_Ternary-new text-sm xs:text-base">
                          Bonus Rules
                        </span>
                      </div>
                    </Link>
                  </div>
                )}
                {IS_B2C && (
                  <div className="w-full border-[#d1d1d1]">
                    <Link
                      to={"/transfer-statement"}
                      onClick={() => {
                        setOpen(false);
                      }}
                    >
                      <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                        <span className="w-4 h-auto xs:w-5 text-text_Primary">
                          <SVG_TransferStatementIcon />
                        </span>
                        <span className="font-medium text-text_Ternary-new text-sm xs:text-base">
                          Transfer Statement
                        </span>
                      </div>
                    </Link>
                  </div>
                )}
              </div>
            </li>

            <li className="divide-y flex items-start justify-start flex-col">
              <span className="font-lato-bold font-semibold text-text_Ternary-new px-3 py-1 w-full border-[#d1d1d1] text-xs xs:text-sm ">
                Account Settings
              </span>
              <div className="divide-y pl-5 flex items-start justify-start w-full flex-col">
                <div className="w-full border-[#d1d1d1]">
                  <Link
                    to="/time-setting"
                    onClick={() => {
                      setOpen(false);
                    }}
                  >
                    <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                      <span className="w-4 h-auto xs:w-5 text-text_Primary">
                        <SVG_TimeSettingIcon />
                      </span>
                      <span className="font-medium  text-text_Ternary-new text-sm xs:text-base">
                        Time Settings
                      </span>
                    </div>
                  </Link>
                </div>
                <div className="w-full border-[#d1d1d1]">
                  <Link
                    to={"/settings"}
                    onClick={() => {
                      setOpen(false);
                    }}
                  >
                    <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                      <span className="w-4 h-auto xs:w-5 text-text_Primary">
                        <SVG_SettingIcon />
                      </span>
                      <span className="font-medium text-text_Ternary-new text-sm xs:text-base">
                        Settings
                      </span>
                    </div>
                  </Link>
                </div>
              </div>
            </li>
            {/* <li className="divide-y flex items-start justify-start flex-col">
              <span className="font-lato-bold font-semibold px-3 py-1 w-full bg-bg_Ternary8 text-xs xs:text-sm text-text_Ternary-new ">
                Legal &amp; Compliance
              </span>
              <div className="divide-y pl-5 flex items-start justify-start w-full flex-col">
                <div className="w-full border-[#d1d1d1]">
                  <Link
                    to={"/rules-regulations"}
                    onClick={() => {
                      setOpen(false);
                    }}
                  >
                    <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 hover:bg-bg_Ternary6  active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                      <span className="w-4 h-auto xs:w-5 text-text_Primary">
                        <SVG_RulesIcon />
                      </span>
                      <span className="font-medium text-sm xs:text-base">
                        Rules &amp; Regulations
                      </span>
                    </div>
                  </Link>
                </div>
                <div className="w-full border-[#d1d1d1]">
                  <Link
                    to={"/exclusion-policy"}
                    onClick={() => {
                      setOpen(false);
                    }}
                  >
                    <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 hover:bg-bg_Ternary6  active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                      <span className="w-4 h-auto xs:w-5 text-text_Primary">
                        <SVG_StopHandIcon />
                      </span>
                      <span className="font-medium text-sm xs:text-base">
                        Exclusion Policy
                      </span>
                    </div>
                  </Link>
                </div>
                <div className="w-full border-[#d1d1d1]">
                  <Link
                    to={"/responsible-gambling"}
                    onClick={() => {
                      setOpen(false);
                    }}
                  >
                    <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 hover:bg-bg_Ternary6  active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                      <span className="w-4 h-auto xs:w-5 text-text_Primary">
                        <SVG_CheckIcon />
                      </span>
                      <span className="font-medium text-sm xs:text-base">
                        Responsible Gambling
                      </span>
                    </div>
                  </Link>
                </div>
                <div className="w-full border-[#d1d1d1]">
                  <Link
                    to={"/privacy-policy"}
                    onClick={() => {
                      setOpen(false);
                    }}
                  >
                    <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 hover:bg-bg_Ternary6  active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                      <span className="w-4 h-auto xs:w-5 text-text_Primary">
                        <SVG_PrivacyIcon />
                      </span>
                      <span className="font-medium text-sm xs:text-base">
                        Privacy Policy
                      </span>
                    </div>
                  </Link>
                </div>
              </div>
            </li> */}
            <li className="divide-y flex items-start justify-start flex-col">
              <span className="font-lato-bold text-text_Ternary-new font-semibold px-3 py-1 w-full bg-border-[#d1d1d1] text-xs xs:text-sm text-text_Ternary-new ">
                Account actions
              </span>
              <div className="divide-y pl-5 flex items-start justify-start w-full flex-col">
                <div className="w-full border-[#d1d1d1]">
                  <Link
                    to="/change-password"
                    onClick={() => {
                      setOpen(false);
                    }}
                  >
                    <div className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer">
                      <span className="w-4 h-auto xs:w-5 text-text_Primary">
                        <SVG_LockIcon />
                      </span>
                      <span className="font-medium text-text_Ternary-new text-sm xs:text-base">
                        Change Password
                      </span>
                    </div>
                  </Link>
                </div>
                <div className="w-full border-[#d1d1d1]">
                  <div
                    className="flex transition-all px-0.5 rounded-sm ease-in-out duration-150 active:scale-[99%] items-center justify-start gap-3 w-full py-2 cursor-pointer"
                    onClick={() => {
                      goLogOut();
                    }}
                  >
                    <span className="w-4 h-auto xs:w-5 text-text_Primary">
                      <SVG_LogOutIcon />
                    </span>
                    <span className="font-medium text-text_Ternary-new text-sm xs:text-base">
                      Sign Out
                    </span>
                  </div>
                </div>
              </div>
            </li>

            {IS_B2C &&
            (location?.pathname == "/" || window.innerWidth >= 1024) ? (
              <li className=" px-3 py-2">
                <span className="flex text-center text-text_Primary-new text-sm xs:text-base font-medium justify-center bg-[bg_text_brand_primary] bg-clip-text">
                  Register online and play online
                </span>
              </li>
            ) : (
              <>
                {IS_B2C && (
                  <>
                    {" "}
                    <li className=" px-3 py-2 flex items-center justify-start gap-x-2 flex-col">
                      <span className="flex text-center text-text_Primary-new text-sm xs:text-base font-medium justify-center bg-[bg_text_brand_primary] bg-clip-text">
                        Register online and play online
                      </span>
                    </li>
                    <li className="p-1"></li>
                  </>
                )}
              </>
            )}

            {(location?.pathname == "/" || window.innerWidth >= 1024) &&
              CONFIG.isContactUsVisisble &&
              IS_B2C && <ContactUs section={"Sidebar"} />}
          </ul>
        </div>
      </div>
      <LockedBounus
        open={LockedBonusPopUp}
        onClose={() => {
          setLockedBonusPopUp(false);
        }}
      />
    </div>
  );
};

export default connectRightSideMenu()(RightSideMenu);
